import { useId } from 'react';

/**
 * Returns a stable unique string suitable for HTML `id` attributes (and related ARIA / label wiring).
 *
 * React's `useId` may include `:`; those are removed so the value is valid as an HTML `id`.
 */
export function useHtmlId<TPrefix extends string>(prefix: TPrefix): string {
  const reactId = useId().replace(/:/g, '');
  return `${prefix}-${reactId}`;
}
